export default "__VITE_ASSET__CJ4_7_rl__"